import type { CSSProperties, FC } from 'react';
import type { EditorObject, EditorOverviewStats, EditorTabKey } from '../types';
import { CloseIcon } from './EditorIcons';

interface EditorStatsOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  stats: EditorOverviewStats;
  objects: EditorObject[];
  onDrillDown: (tab: EditorTabKey, selectedObject?: EditorObject) => void;
}

/** Stats — cab-overlay chrome + cabinet-* body. */
export const EditorStatsOverlay: FC<EditorStatsOverlayProps> = ({
  isOpen,
  onClose,
  stats,
  objects,
  onDrillDown,
}) => {
  if (!isOpen) return null;

  return (
    <div className="cab-overlay" role="dialog" aria-modal="true">
      <div className="cab-shell cab-shell--wide cab-shell--tall">
        <div className="cab-top">
          <div className="cab-top-left">
            <div>
              <small>Редакционный проект</small>
              <h2>Статистика</h2>
              <p>Принятые, возвращённые, ожидающие и завершённые материалы</p>
            </div>
          </div>
          <div className="cab-top-actions">
            <button type="button" className="cab-btn icon" onClick={onClose} aria-label="Закрыть">
              <CloseIcon className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="cab-body">
          <section className="cabinet-hero" style={{ '--accent': '#9e80ff' } as CSSProperties}>
            <div>
              <div className="cabinet-eyebrow">Рабочий центр</div>
              <h2>Статистика</h2>
              <p>
                Сводное представление по редакционным объектам текущего контура.
              </p>
            </div>
            <span className="cabinet-badge" style={{ '--badge': '#9e80ff' } as CSSProperties}>
              Роль: Редактор проекта
            </span>
          </section>

          <section className="cabinet-kpis" style={{ marginTop: 14 }}>
            <button
              type="button"
              className="cabinet-kpi"
              style={{ '--accent': '#8faebb', textAlign: 'left', cursor: 'pointer' } as CSSProperties}
              onClick={() => onDrillDown('ALL')}
            >
              <small>Всего объектов</small>
              <strong>{stats.total_objects}</strong>
            </button>
            <button
              type="button"
              className="cabinet-kpi"
              style={{ '--accent': '#41d2ff', textAlign: 'left', cursor: 'pointer' } as CSSProperties}
              onClick={() => onDrillDown('ALL')}
            >
              <small>Активные</small>
              <strong>{stats.active_objects}</strong>
            </button>
            <button
              type="button"
              className="cabinet-kpi"
              style={{ '--accent': '#e2ad3a', textAlign: 'left', cursor: 'pointer' } as CSSProperties}
              onClick={() => onDrillDown('APPROVAL')}
            >
              <small>На согласовании</small>
              <strong>{stats.in_approval_objects}</strong>
            </button>
            <button
              type="button"
              className="cabinet-kpi"
              style={{ '--accent': '#49ddb7', textAlign: 'left', cursor: 'pointer' } as CSSProperties}
              onClick={() => onDrillDown('DONE')}
            >
              <small>Завершённые</small>
              <strong>{stats.completed_objects}</strong>
            </button>
          </section>

          <section style={{ marginTop: 16 }}>
            <div className="cabinet-actions" style={{ marginBottom: 10 }}>
              <h3 style={{ margin: 0, fontSize: 15 }}>Детализация по объектам</h3>
              <span className="cabinet-spacer" />
              <span style={{ fontSize: 12, color: '#8faebb' }}>Клик — переход в «Мои заявки»</span>
            </div>
            <div className="cabinet-stack">
              {objects.map((obj) => (
                <button
                  key={obj.id}
                  type="button"
                  className="cabinet-card"
                  style={
                    {
                      '--accent': '#41d2ff',
                      textAlign: 'left',
                      cursor: 'pointer',
                      width: '100%',
                    } as CSSProperties
                  }
                  onClick={() => onDrillDown(obj.kind as EditorTabKey, obj)}
                >
                  <div className="cabinet-actions">
                    <span className="cabinet-badge" style={{ '--badge': '#41d2ff' } as CSSProperties}>
                      {obj.kind} · {obj.object_code}
                    </span>
                    <span className="cabinet-spacer" />
                    <span style={{ fontSize: 12, color: '#8faebb' }}>
                      {obj.status} · {obj.target_deadline || '—'}
                    </span>
                  </div>
                  <strong style={{ display: 'block', marginTop: 8 }}>{obj.title}</strong>
                  <div className="cabinet-actions" style={{ marginTop: 10 }}>
                    <span className="cabinet-spacer" />
                    <span className="cabinet-btn">Открыть в заявках →</span>
                  </div>
                </button>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
